import { gsap } from 'gsap';

export class Graph {
  constructor() {
    const container = document.querySelector('.p-index_why__graph');
    if (!container) return;

    const observer = new MutationObserver(() => {
      if (!container.classList.contains('is-act')) return;
      observer.disconnect();

      const line = container.querySelector('.graph-svg path:last-of-type');
      if (!line) return;

      const len = line.getTotalLength();
      gsap.set(line, { strokeDasharray: len, strokeDashoffset: len });
      gsap.to(line, {
        strokeDashoffset: 0,
        duration: 3,
        delay: 0.5,
        ease: 'power1.out'
      });
    });

    observer.observe(container, { attributes: true, attributeFilter: ['class'] });
  }
}